package com.macrofocus.eflux.animation

import com.macrofocus.eflux.network.EFluxNode
import svgpanzoom.SvgPanZoomContext
import web.geometry.DOMPoint

class PanToAnimation(private val to: EFluxNode?, private val svgPanZoom: SvgPanZoomContext, override val duration: Long, private val easing: Easing = Easing.LINEAR) :
    AbstractAnimation() {
    private var startX: Double? = null
    private var startY: Double? = null
    private var endX: Double? = null
    private var endY: Double? = null

    override fun start() {
//        val startSVG = from.screenToSVG(svgPanZoomContext.getPan().x.unsafeCast<Double>(), svgPanZoomContext.getPan().y.unsafeCast<Double>())
//        println("From (boundingClientRect): ${from.boundingClientRect.x}, ${from.boundingClientRect.y} to  ${to.boundingClientRect.x}, ${to.boundingClientRect.y}")
//        println("From (anchorSVG): ${from.anchorSVG.x}, ${from.anchorSVG.y} to  ${to.anchorSVG.x}, ${to.anchorSVG.y}")
//        val fromSvg = from.screenToSVG(from.screenX, from.screenY)
//        val toSvg = to.screenToSVG(to.screenX, to.screenY)
//        println("From (screenToSVG): ${fromSvg.x}), ${fromSvg.y} to  ${toSvg.x}, ${toSvg.y}")
//        println("From (schema): ${from.schemaX}, ${from.schemaY} to  ${to.schemaX}, ${to.schemaY}")
//        println("From (screen): ${from.screenX}, ${from.screenY} to  ${to.screenX}, ${to.screenY}")

        startX = svgPanZoom.getPan().x.unsafeCast<Double>()
        startY = svgPanZoom.getPan().y.unsafeCast<Double>()

//        val sizes: dynamic = svgPanZoom.getSizes()
//        val viewBox: dynamic = sizes.viewBox
//        val width = sizes.width.unsafeCast<Double>()
//        val height = sizes.height.unsafeCast<Double>()
//        val realZoom = sizes.realZoom.unsafeCast<Double>()
//        val viewBoxX = viewBox.x.unsafeCast<Double>()
//        val viewBoxY = viewBox.y.unsafeCast<Double>()
//        val viewBoxWidth = viewBox.width.unsafeCast<Double>()
//        val viewBoxHeight = viewBox.height.unsafeCast<Double>()
//        println("Sizes: width: $width, height: $height, realZoom: $realZoom, viewBoxX: $viewBoxX, viewBoxY: $viewBoxY, viewBoxWidth: $viewBoxWidth, viewBoxHeight: $viewBoxHeight")

//        val offsetX: Double = (width - (viewBoxWidth + viewBoxX * 2.0) * svgPanZoom.getZoom()) * 0.5
//        val offsetY: Double = (height - (viewBoxHeight + viewBoxY * 2.0) * svgPanZoom.getZoom()) * 0.5

//        println("Offset: $offsetX,$offsetY")

//        println("Screen to : ${to.screenPanZoomCenter.x},${to.screenPanZoomCenter.y}")

        endX = to!!.screenPanZoomCenter.x + startX!!
        endY = to.screenPanZoomCenter.y + startY!!

        println("Start: $startX,$startY, end: $endX, $endY")
    }

    override fun tick(time: Long) {
        val normalizedTime = time.toDouble() / duration

        val currentX = interpolate(startX!!, endX!!, normalizedTime)
        val currentY = interpolate(startY!!, endY!!, normalizedTime)

//        var projected = to.svgToScreen(currentX, currentY)

//        val sizes = svgPanZoomContext.getSizes()
//        val viewBox = sizes.viewBox
//        val width = viewBox.width.unsafeCast<Double>()
//        val height = viewBox.height.unsafeCast<Double>()

//        val panX = projected.x / width
//        val panY = projected.y / height

//        svgPanZoom.pan(object {
//            val x = currentX
//            val y = currentY
//        })
        svgPanZoom.pan(DOMPoint(currentX, currentY))
        if(normalizedTime == 0.0) {
            println("Started pan: start: $startX,$startY, end: $endX,$endY -> $currentX,$currentY (${svgPanZoom.getPan().x},${svgPanZoom.getPan().y})")
        } else if(normalizedTime >= 1.0) {
            println("Finished pan: start: $startX,$startY, end: $endX,$endY -> $currentX,$currentY (${svgPanZoom.getPan().x},${svgPanZoom.getPan().y})")
        }
    }
}